import {createFileRoute} from '@tanstack/react-router';

import {categoryKeys} from '@/features/Library/api/queryKeys';
import {getCategory} from '@/features/Library/api/readCategory';
import {CategoryModal} from '@/features/Library/components/Category/CategoryModal';
import {makeDocumentTitle} from '@/utils/makeDocumentTitle';

export const Route = createFileRoute('/_b/_p/_library/categories/$categoryId')({
  component: CategoryModal,

  beforeLoad: ({params, context}) => {
    makeDocumentTitle(params.categoryId);

    return {
      ...context,
      readCategoryQuery: {
        queryKey: categoryKeys.detail(params.categoryId),
        queryFn: () => getCategory(params.categoryId),
      },
    };
  },

  loader({context}) {
    return context.queryClient.ensureQueryData(context.readCategoryQuery);
  },
});
